/**
 * Applies logical OR to a column.
 * Column has to be boolean type (eg checkbox).
 * 
 * @param {any} data
 * @param {any} row
 * @param {any} col
 * @param {any} from
 * @param {any} to
 */
export default function (data, row, col, from, to) {
    from = from < 0 ? row + 1 : from;
    to = to < 0 ? data.length - 1 : to;

    let isTrue = false;
    for (let r = from; r <= to; r++) {
        const value = data[r][col];
        if (typeof (value) !== "boolean") {
            continue;
        }
        isTrue = isTrue || value;
    }

    return { value: isTrue };
}


// WEBPACK FOOTER //
// ./App/components/Handsontable/functions/color.js